import LogoIconImageNegative from "./logo/KV-Monogram-Color-Negative.png";



const LogoIcon = () => (
  <img height="auto"
    width={32}
    src={LogoIconImageNegative}
    alt="Kinetic Vision Logo"
  />
);

export default LogoIcon;
